// extracted by mini-css-extract-plugin
module.exports = {"arrowIcon":"styles_arrowIcon__SfMuV","expanded":"styles_expanded__pGybX"};